// Will fix translations below
export const modes = {
	light: '',
	dark: '',
};

export enum NetxThemePref {
	DEFAULT = 'default',
	DARK = 'dark',
	LIGHT = 'light',
}

export const NetxThemePrefLabels = {
	[NetxThemePref.DEFAULT]: i18n.t('i18n.themeModeDefault'),
	[NetxThemePref.DARK]: i18n.t('i18n.themeModeDark'),
	[NetxThemePref.LIGHT]: i18n.t('i18n.themeModeLight'),
};

export const userPref = 'app:brand:mode';

// Fix translations since we are loaded in tendem with i18n
dispatcher.once('app:i18n:ready', () => {
	Object.assign(NetxThemePrefLabels, {
		[NetxThemePref.DEFAULT]: i18n.t('i18n.themeModeDefault'),
		[NetxThemePref.DARK]: i18n.t('i18n.themeModeDark'),
		[NetxThemePref.LIGHT]: i18n.t('i18n.themeModeLight'),
	});
});

export default {modes, userPref};
